import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileNav from "@/components/MobileNav";
import Home from "@/pages/Home";
import Mandi from "@/pages/Mandi";
import Trade from "@/pages/Trade";
import Analytics from "@/pages/Analytics";
import Login from "@/pages/Login";
import CreateListing from "@/pages/CreateListing";
import Profile from "@/pages/Profile";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Legal from "@/pages/Legal";
import Schemes from "@/pages/Schemes";
import Khaad from "@/pages/Khaad";
import Beej from "@/pages/Beej";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  const { user } = useAuth();
  // Detect OAuth callback fragment SYNCHRONOUSLY during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/mandi" element={<Mandi />} />
          <Route path="/trade" element={<Trade />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/schemes" element={<Schemes />} />
          <Route path="/khaad" element={<Khaad />} />
          <Route path="/beej" element={<Beej />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/login" element={<Login />} />
          <Route path="/listings/new" element={<CreateListing />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </main>
      {!user && <Footer />}
      <MobileNav />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#FDFBF7] pb-16 lg:pb-0">
            <AppRouter />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
